module.exports = __webpack_public_path__ + "static/media/easy.6fa74d77.svg";